
class TestReports {

  constructor() { }

  formatJSON(data) {
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }

    return JSON.stringify(data, null, 2);
  }

  wrapJSON(data) {
    if (typeof data === 'string') {
      data = JSON.parse(data);
      if( typeof data.ervive_data === 'string' ) {
        data.ervive_data  = JSON.parse( data.ervive_data)
      }
      if( typeof data.encounters_data  === 'string') {
        data.encounters_data = JSON.parse( data.encounters_data)
      }
      if(typeof data.ors_v2_data === 'string' ) {
        data.ors_v2_data  = JSON.parse( data.ors_v2_data)
      }
      if(typeof data.render?.feature_flags?.visano_layout_configuration === 'string' ) {
        data.render.feature_flags.visano_layout_configuration = JSON.parse(data.render.feature_flags.visano_layout_configuration)
      }
      return JSON.stringify(data, null, 2);
    }

    return data
  }

  unwrapJSON(data){
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }

    if (typeof data === "object" && data !== null) {
      if( typeof data.ervive_data === "object" && data.ervive_data !== null) {
        data.ervive_data  = `${JSON.stringify( data.ervive_data) }`
      }
      if( typeof data.encounters_data === 'object' && data.encounters_data !== null) {
        data.encounters_data = `${JSON.stringify( data.encounters_data ) }`
      }
      if( typeof data.ors_v2_data === "object"  && data.ors_v2_data !== null) {
        data.ors_v2_data  = `${JSON.stringify( data.ors_v2_data ) }`
      }

      if(typeof data.render?.feature_flags?.visano_layout_configuration === 'object' &&
        data.render?.feature_flags?.visano_layout_configuration  !== null ) {
        data.render.feature_flags.visano_layout_configuration = `${JSON.stringify(data.render.feature_flags.visano_layout_configuration)}`
      }
    }

    return JSON.stringify(data, null, 2);
  }


}


export { TestReports }


